/**
 * Data visualization: Lemon colors
 */
export var lemon10 = '#edfbab';
export var lemon20 = '#dff378';
export var lemon30 = '#cfe854';
export var lemon40 = '#bed83c';
export var lemon40opacity20solidDark = '#444e35';
export var lemon50 = '#a9c22b';
export var lemon60 = '#8fa61f';
export var lemon60opacity20solid = '#e7eccf';
export var lemon60opacity20solidDark = '#3a442f';
export var lemon70 = '#728416';
export var lemon80 = '#53610f';
export var lemon80opacity20solid = '#dcdfcd';
